export default "__VITE_ASSET__C7v1MZA5__"